import React, { useRef, useState } from "react";
import {
  CustomAmountInput,
  CustomDropDown,
  CustomForm,
  CustomInput,
} from "shared/AllInputs";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import formValidation from "utils/validations";
import CustomOverlay from "shared/CustomOverlay";
import CustomModal from "shared/Modals/CustomModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteEnergyMeterAction,
  updateEnergyMeterAction,
} from "store/actions/buildingUnitActions";
import { handleDelete } from "shared/Components/commonFunctions";
import { Toast } from "primereact/toast";
import {
  convertAmountInGerman,
} from "utils/commonFunctions";
import {
  AccessOptions,
  ElectricityuPurposeOptions,
  GasPurposeOptions,
  LocationOptions,
  MeterTypeOpt,
} from "shared/AllDropDownOptions";
import { spaceNotAllowed } from "utils/regex";
import { Sidebar } from "primereact/sidebar";
import AddEnergyClocks from "shared/Components/AddEnergyClock";
import { useParams } from "react-router-dom";
import { getPorpertyInfoAction } from "store/actions/propertyActions";
import CrossIcon from "assets/images/svg/cross-icon.svg"
import SaveIcon from "assets/images/svg/Save-icon.svg"
import SizeM3 from "assets/images/svg/sizem3.svg"
import KWHIcon from "assets/images/svg/kwhIcon.svg"

export default function CustomEnergyTable({
  id,
  title,
  allEnergyMeters,
  setAllEnergyMeters,
}) {
  const msgs = useRef(null);
  const dispatch = useDispatch();
  const [editingRows, setEditingRows] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [idToDelete, setIdToDelete] = useState({ id: "", index: "" });
  const [meterType, setMeterType] = useState("");
  const [openRightbar, setOpenRightbar] = useState({
    isOpen: false,
    id: "",
  });
  const { profile } = useSelector((state) => state.user);
  const params = useParams();
  const [visible, setVisible] = useState(false);

  const onShow = () => {
    document.body.classList.add('no-scroll');
  };

  const onHide = () => {
    document.body.classList.remove('no-scroll');
  };

  const TypeEditor = (options) => {
    const formErrors = formValidation("type", options.value, allEnergyMeters);
    setMeterType(options.value);
    return (
      <CustomDropDown
        value={options.value}
        onChange={(e) => {
          options.editorCallback(e.target.value);
        }}
        name="type"
        col={12}
        extraClassName="p-0"
        options={MeterTypeOpt}
        ignoreLabel
        errorMessage={formErrors["type"]}
      />
    );
  };

  const PurposeEditor = (options) => {
    const formErrors = formValidation(
      "purpose",
      options.value,
      allEnergyMeters
    );
    return (
      <CustomDropDown
        value={options.value}
        onChange={(e) => {
          options.editorCallback(e.target.value);
        }}
        name="purpose"
        col={12}
        extraClassName="p-0"
        options={
          meterType === "Electricity"
            ? ElectricityuPurposeOptions
            : GasPurposeOptions
        }
        ignoreLabel
        errorMessage={formErrors["purpose"]}
      />
    );
  };

  const MeterIdEditor = (options) => {
    const formErrors = formValidation(
      "meter_id",
      options.value,
      allEnergyMeters
    );

    return (
      <CustomInput
        value={options.value}
        col={12}
        extraClassName="p-0"
        onChange={(e) => {
          const value = e.target.value;
          if (spaceNotAllowed(value)) {
            options.editorCallback(value.toUpperCase());
          } else if (!value) {
            options.editorCallback(value);
          }
        }}
        name="meter_id"
        ignoreLabel
        errorMessage={formErrors["meter_id"]}
      />
    );
  };

  const LocationEditor = (options) => {
    const formErrors = formValidation(
      "location",
      options.value,
      allEnergyMeters
    );
    return (
      <CustomDropDown
        value={options.value}
        onChange={(e) => {
          options.editorCallback(e.target.value);
        }}
        name="location"
        col={12}
        extraClassName="p-0"
        options={LocationOptions}
        ignoreLabel
        errorMessage={formErrors["location"]}
      />
    );
  };

  const AccessEditor = (options) => {
    const formErrors = formValidation("access", options.value, allEnergyMeters);
    return (
      <CustomDropDown
        value={options.value}
        onChange={(e) => {
          options.editorCallback(e.target.value);
        }}
        name="access"
        col={12}
        extraClassName="p-0"
        options={AccessOptions}
        ignoreLabel
        errorMessage={formErrors["access"]}
      />
    );
  };

  const AmountEditor = (options) => {
    const formErrors = formValidation("amount", options.value, allEnergyMeters);
    return (
      <CustomAmountInput
        type="text"
        col={12}
        extraClassName="p-0"
        value={options.value}
        onChange={(e) => options.editorCallback(e.value)}
        spanIcon={meterType === "Electricity" ? KWHIcon : SizeM3}
        spanExtraClassName={"p-1"}
        name="amount"
        ignoreLabel
        errorMessage={formErrors["amount"]}
      />
    );
  };

  const actions = (rowData, options) => {
    return (
      <>
        {options.rowEditor?.editing ? (
          <>
            <a
              className="cursor-pointer"
              style={{ cursor: "pointer" }}
              onClick={(e) => handleSave(rowData, options, e)}
            >
              <img src={SaveIcon} />
            </a>
            <a
              className="cursor-pointer"
              onClick={(e) =>
                options.rowEditor?.onCancelClick &&
                options.rowEditor?.onCancelClick(e)
              }
            >
              {" "}
              <img src={CrossIcon} />
            </a>
          </>
        ) : (
          <>
            <CustomOverlay>
              <ul className="no-style p-0">
                <li
                  className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                  onClick={() => handleEditRow(rowData)}
                >
                  <i className="pi pi-file-edit text-dark"></i>
                  Edit
                </li>
                <li
                  className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                  onClick={() =>
                    setOpenRightbar({
                      isOpen: true,
                      id: rowData?.id,
                    })
                  }
                >
                  <i className="pi pi-bolt text-dark"></i>
                  Energy Clock
                </li>
                <li className="flex gap-2 text-xs font-medium mb-3">
                  <i
                    className="pi pi-trash cursor-pointer text-dark"
                    onClick={() => {
                      setIdToDelete({
                        id: rowData?.id,
                        index: options?.rowIndex,
                      });
                      setDeleteModal(true);
                    }}
                  ></i>{" "}
                  Delete
                </li>
              </ul>
            </CustomOverlay>
          </>
        )}
      </>
    );
  };

  const handleEditRow = (rowData) => {
    const val = { ...{ [`${rowData?.id}`]: true } };
    setEditingRows(val);
  };

  const rowEditValidator = async (rowData, options) => {
    const { type, purpose, meter_id, location, access, amount } = rowData;
    const typeError = formValidation("type", type, allEnergyMeters);
    const purposeError = formValidation("purpose", purpose, allEnergyMeters);
    const meteridError = formValidation("meter_id", meter_id, allEnergyMeters);
    const locationError = formValidation("location", location, allEnergyMeters);
    const accessError = formValidation("access", access, allEnergyMeters);
    const amountError = formValidation("amount", amount, allEnergyMeters);

    if (
      !typeError["type"] &&
      !purposeError["purpose"] &&
      !meteridError["meter_id"] &&
      !locationError["location"] &&
      !accessError["access"] &&
      !amountError["amount"]
    ) {
      let payload = {
        type: type,
        purpose: purpose,
        meter_id: meter_id,
        location: location,
        access: access,
        amount: amount,
        building_unit: id,
      };
      dispatch(
        updateEnergyMeterAction(rowData?.id, payload, dispatch, (res) => {
          let meters = [...allEnergyMeters];
          meters[options.rowIndex] = rowData;
          setAllEnergyMeters(meters);
          setEditingRows({});
          dispatch(getPorpertyInfoAction(profile?.company, params?.id, dispatch));
        })
      );
    } else {
      return false;
    }
  };

  const handleSave = async (rowData, options, e) => {
    options?.rowEditor?.onSaveClick(e);
    const val = { ...{ [`${rowData?.id}`]: true } };
    setEditingRows(val);
  };

  const onRowEditChange = (e) => {
    setEditingRows(e.data);
  };

  const handleDeleteEnergyMeter = () => {
    dispatch(
      deleteEnergyMeterAction(idToDelete?.id, setLoading, dispatch, (res) => {
        handleDelete(allEnergyMeters, setAllEnergyMeters, "", "", idToDelete?.index);
        setIdToDelete({ id: "", index: "" });
        setDeleteModal(false);
        dispatch(getPorpertyInfoAction(profile?.company, params?.id, dispatch));
      })
    );
  };

  const modalContent = () => {
    return (
      <span>
        Are you sure you want to delete the selected energy meter from the list?
        This action cannot be undone.
      </span>
    );
  };

  const customHeader = (
    <div className="">
      <div className="sidebar-title">Energy Clock </div>
    </div>
  );

  return (
    <CustomForm title={title}>
      <Toast ref={msgs} />
      <DataTable
        className="col-12 editor-container table-error-align"
        value={allEnergyMeters}
        editMode="row"
        dataKey="id"
        editingRows={editingRows}
        onRowEditChange={onRowEditChange}
        // onRowEditComplete={onRowEditComplete}
        rowEditValidator={rowEditValidator}
        onRowEditSave={handleSave}
        tableStyle={{ minWidth: "50rem" }}
      >
        <Column
          headerClassName="custom-header"
          field="type"
          header="Type"
          editor={(options) => TypeEditor(options)}
          style={{ width: "200px" }}
        ></Column>
        <Column
          headerClassName="custom-header"
          field="purpose"
          header="Purpose"
          editor={(options) => PurposeEditor(options)}
          style={{ width: "200px" }}
        ></Column>
        <Column
          headerClassName="custom-header"
          field="meter_id"
          header="Meter ID"
          editor={(options) => MeterIdEditor(options)}
          style={{ width: "200px" }}
        ></Column>
        <Column
          headerClassName="custom-header"
          field="location"
          header="Location"
          editor={(options) => LocationEditor(options)}
          style={{ width: "200px" }}
        ></Column>
        <Column
          headerClassName="custom-header"
          field="access"
          header="Access"
          editor={(options) => AccessEditor(options)}
          style={{ width: "200px" }}
        ></Column>
        <Column
          headerClassName="custom-header"
          field="amount"
          header="Amount"
          body={(rowData) => {
            return rowData?.type == "Gas" ? (
              <span className="lowercase-text">
                {rowData.amount ? (
                  <>
                    {convertAmountInGerman(rowData.amount)}
                    <span
                      dangerouslySetInnerHTML={{ __html: " m<sup>3</sup>" }}
                    />
                  </>
                ) : (
                  "-----"
                )}
              </span>
            ) : (
              <span className="lowercase-text">
                {rowData.amount
                  ? convertAmountInGerman(rowData.amount) + " kWh"
                  : "-----"}
              </span>
            );
          }}
          editor={(options) => AmountEditor(options)}
          style={{ width: "200px" }}
        ></Column>
        <Column
          header="Action"
          headerClassName="custom-header"
          rowEditor
          style={{ width: "200px" }}
          body={(rowData, options) => actions(rowData, options)}
        ></Column>
      </DataTable>
      <Sidebar
        header={customHeader}
        className="view-enery-meter-sidebar"
        visible={openRightbar.isOpen}
        position="right"
        // appendTo="body" 
        onShow={() => document.body.classList.add('no-scroll')}
        onHide={() => {
          document.body.classList.remove('no-scroll');
          setOpenRightbar({ isOpen: false, id: "" });
        }}
      >
        <div className="" id="view-enery-meter-sidebar">
          <AddEnergyClocks meterId={openRightbar?.id} />
        </div>
      </Sidebar>
      <CustomModal
        isOpen={deleteModal}
        setIsOpen={setDeleteModal}
        heading={"Delete"}
        body={modalContent}
        submitLabel={"Confirm"}
        onSubmit={handleDeleteEnergyMeter}
        loading={loading}
      />
    </CustomForm>
  );
}
